const index = () => import(/* webpackChunkName: "herb" */ './Index');
const manager = () => import(/* webpackChunkName: "herb" */ './managerIndex');

//2019年省级工业转型升级专项资金
export default {
  routes: [
    {
      path: '/guide/guide/v2021/index',
      name: 'guide_guide_v2021_index',
      component: index,
      meta:{public:true}
    },
    {
      path: '/guide/guide/v2021/manager',
      name: 'guide_guide_v2021_manager',
      component: manager,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/guide/guide/v2021/router.js